import { render, staticRenderFns } from "./ProfileReferencesView.vue?vue&type=template&id=4485b0c8&scoped=true"
import script from "./ProfileReferencesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileReferencesView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileReferencesView.vue?vue&type=style&index=0&id=4485b0c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4485b0c8",
  null
  
)

export default component.exports